var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.67929 2.76613C1.27398 2.39097 0.641287 2.41541 0.266127 2.82071C-0.109033 3.22602 -0.0845938 3.85871 0.320713 4.23387L1.67929 2.76613ZM3.70089 6L3.02161 6.73387C3.22276 6.92006 3.49151 7.01552 3.76504 6.99794C4.03857 6.98036 4.2929 6.85127 4.46855 6.64086L3.70089 6ZM8.64266 1.64086C8.9966 1.21689 8.93982 0.586277 8.51586 0.232341C8.09189 -0.121596 7.46128 -0.0648248 7.10734 0.359142L8.64266 1.64086ZM0.320713 4.23387L3.02161 6.73387L4.38018 5.26613L1.67929 2.76613L0.320713 4.23387ZM4.46855 6.64086L8.64266 1.64086L7.10734 0.359142L2.93323 5.35914L4.46855 6.64086Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.6fb63269eb8d071c1a6e1ffb1bfeaddc.svg";
export { ForwardRef as ReactComponent };